import { render, staticRenderFns } from "./UsersTasksDashboard.vue?vue&type=template&id=2a39a684&scoped=true&"
import script from "./UsersTasksDashboard.vue?vue&type=script&lang=js&"
export * from "./UsersTasksDashboard.vue?vue&type=script&lang=js&"
import style0 from "./UsersTasksDashboard.vue?vue&type=style&index=0&id=2a39a684&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a39a684",
  null
  
)

export default component.exports